const swiperChampionshipLineUp = {
    swiperInstance: null,
    init: () => {
        import("swiper/bundle").then(({ Swiper }) => {
            let domEls = document.querySelectorAll(
                ".js-swiper-championship-line-up"
            );
            if (domEls) {
                const params = getSwiperParams();
                domEls.forEach((el) => {
                    swiperChampionshipLineUp.swiperInstance = new Swiper(
                        el,
                        params
                    );
                });
            }
        });
    },
};

const getSwiperParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: false,
        spaceBetween: 14,
        slidesPerView: 2,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        mousewheel: {
            forceToAxis: true,
        },
        grabCursor: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
            type: "progressbar",
        },
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 14,
            },
            1024: {
                slidesPerView: 4,
                spaceBetween: 10
            }
        },
    };
};

export default swiperChampionshipLineUp;
